import React from 'react';
import NavSearch from '@features/nav-search';
import Portal from "@/root/portals/Portal";
import ErrorBoundary from '@components/tailwind/ErrorBoundary';
import { lazyRetry } from '@utils/lazyRetry';

const LazyDebugger = React.lazy(() =>
  lazyRetry(
    () => import(/* webpackChunkName: "debugger" */ '@/components/Debugger'),
    'debugger'
  )
);

const Debugger = () => <React.Suspense><LazyDebugger/></React.Suspense>

export default () => {
  return <ErrorBoundary silent>
    <Portal selector='#module-debug'>
      {(dataset) => React.createElement(Debugger, dataset)}
    </Portal>
  </ErrorBoundary>
};
